var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookGrey = function SvgFacebookGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-128)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(128)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1977F3",
    d: "M134.25,6.875v-2.5a1.25,1.25,0,0,1,1.25-1.25h1.25V0h-2.5a3.75,3.75,0,0,0-3.75,3.75V6.875H128V10h2.5V20h3.75V10h2.5L138,6.875Z",
    transform: "translate(-128)"
  })))));
};
export default SvgFacebookGrey;